import { ID, Task } from '@griply/types';
import { chunkArray } from '@griply/utils';

import { getTaskDocs } from './get-tasks';

// One-shot read by id (no listener); chunks the Firestore `in` limit of 30.
export const getTasksByIds = async (ids: ID[]): Promise<Task[]> => {
  if (!ids.length) {
    return [];
  }

  const results = await Promise.all(
    chunkArray([...ids], 30).map((chunk) => getTaskDocs({ ids: chunk })),
  );

  return results.flat().filter((task) => !task.deletedAt);
};
